module.exports = __webpack_public_path__ + "img/trainings.2c070c0c.jpg";